import script from "./CareerView.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerView.vue?vue&type=script&setup=true&lang=js"

import "./CareerView.vue?vue&type=style&index=0&id=54f15848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f15848"]])

export default __exports__